import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CreateLike, LikeUpdate } from "../../../hooks/Likehook";
import { toast, ToastContainer } from "react-toastify";
// import { avatar } from "../../assets/img";
import itemLogo from "../../../assets/img/items/item_1.png";
import { GweiToether } from "../../../hooks/Tokenhook";
import { Badge, Button, Modal } from "react-bootstrap";
import { ContractABI } from "../../../config/ABIs/ContractABI";
import { useDispatch, useSelector } from "react-redux";
import { ethers } from "ethers";
import { FaRegCirclePlay } from "react-icons/fa6";
import { avatar, DefaultProfile } from "../../../assets/img";
import { likeNFT } from "../../../hooks/NFTHook";

const userId = localStorage.getItem("userId");

const DynamicCardProfile = ({
    NFTLink,
    contractAddress,
    mediaUrl,
    assetType,
    title,
    price,
    isLiked,
    likes,
    tokenId,
    isListed,
    button,
    buttonMessage,
    isLazy,
    onTrade,
    nftId
}) => {
    const [hover, setHover] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const location = useLocation();
    const [openModalState, setOpenModalState] = useState(false);
    const [nftAction, setNftAction] = useState(null);
    const [fav, setFav] = useState(isLiked);
    const [likeCount, setLikeCount] = useState(likes);

    const [selectedNFT, setSelectedNFT] = useState(null);
    const [priceforMarket, setPriceForMarket] = useState('');
    const [receiverAddress, setReceiverAddress] = useState('');
    // console.log("location", location.pathname.split('/')[1], location.pathname.split('/')[1] === "nftdetails");
    const closeModal = () => {
        setOpenModalState(false);
        setNftAction(null);
        setPriceForMarket('');
        setReceiverAddress('');
    };
    const walletAddress = localStorage.getItem("WalletAddress");
    const PROVIDER = useSelector((state) => state.valueFromHeader);
    const route = useNavigate();

    const redirect = () => {
        if (location.pathname.split('/')[1] === "nftdetails") {
            localStorage.setItem('stateManage', true)
            route(NFTLink)
        }
        else {
            route(NFTLink)
        }
    }

    const redeployOnMarketplace = async () => {
        if (!price || isNaN(price)) {
            toast.error("Invalid price. Please enter a valid amount.");
            return;
        }

        try {
            const wallet = await PROVIDER.getSigner();
            const contract = new ethers.Contract(contractAddress, ContractABI, wallet);
            const priceInEther = ethers.parseEther(price);
            const transaction = await contract.addNftToMarket(selectedNFT.tokenId, priceInEther);
            const receipt = await transaction.wait();
            if (receipt) {
                toast.success("NFT added to the marketplace successfully!");
                setTimeout(() => route('/marketplace'), 2000);
            }
        } catch (error) {
            console.error("Error redeploying NFT:", error);
            toast.error("Error redeploying NFT: " + error.message);
        }
    };

    const sendNFT = async () => {
        if (!receiverAddress || !ethers.isAddress(receiverAddress)) {
            toast.error("Invalid recipient address.");
            return;
        }

        try {
            const wallet = await PROVIDER.getSigner();
            const contract = new ethers.Contract(contractAddress, ContractABI, wallet);
            const transaction = await contract.transferFrom(walletAddress, receiverAddress, selectedNFT.tokenId);
            const receipt = await transaction.wait();
            if (receipt) {
                closeModal();
                toast.success("NFT sent successfully!");

            }
        } catch (error) {
            console.error("Error sending NFT:", error);
            toast.error("Error sending NFT: " + error.message);
        }
    }

    const handleLike = (e) => {
        console.log("handleLike triggered"); // Debug log
        e.stopPropagation();

        if (!userId) {
            toast.dismiss();
            toast.error("Please login first!");
            return;
        }

        const body = { userId: userId };

        if (!fav) {
            console.log("Liking NFT"); // Debug log
            toast.dismiss();
            likeNFT(nftId, body)
                .then((data) => {
                    if (data.success) {
                        console.log("Like Data", data);
                        setLikeCount(Number(likeCount) + 1)
                        setFav(true);
                        toast.success("Liked Successfully!");
                    }
                })
                .catch((error) => {
                    console.error("Error liking NFT:", error);
                    toast.error("Failed to like. Please try again.");
                });
        } else {
            console.log("Disliking NFT"); // Debug log
            toast.dismiss();
            likeNFT(nftId, body)
                .then((data) => {
                    if (data.success) {
                        setLikeCount(Number(likeCount) - 1)

                        setFav(false);
                        toast.success("Disliked Successfully!");
                    }
                })
                .catch((error) => {
                    console.error("Error unliking NFT:", error);
                    toast.error("Failed to dislike. Please try again.");
                });
        }
    };

    return (
        <>
            <div
                className={` ${hover ? "hovered" : ""}`}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}

            >
                <div >
                    <div className="card__item four">
                        <div className="card_body space-y-10">
                            <div className="creators space-x-10 justify-content-end"
                            style={{position:"right"}}

                            >

                                    {isListed === false &&
                                        <Badge pill bg="danger" className="ml-2">Not Listed</Badge>
                                    }
                            </div>
                            <div className="card_head" onClick={() => redirect()}>
                                {assetType?.split("/")[0] !== "image" ? (
                                    <div
                                        className="video-wrapper"
                                        onMouseEnter={() => setIsHovered(true)}
                                        onMouseLeave={() => setIsHovered(false)}
                                        style={{ width: '100%', height: '300px', position: 'relative', overflow: 'hidden', borderRadius: '18px' }}
                                    >
                                        <video
                                            style={{ 
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                borderRadius: '18px',
                                                position: 'absolute',
                                                top: '0',
                                                left: '0'
                                            }}
                                            muted
                                            loop
                                            playsInline
                                            className={`video ${isHovered ? "playing" : ""}`}
                                            onMouseEnter={(e) => e.target.play()}
                                            onMouseLeave={(e) => e.target.pause()}
                                        >
                                            <source src={mediaUrl} type={assetType} />
                                            Your browser does not support the video tag.
                                        </video>
                                        {!isHovered && <div className="pause-overlay" style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            fontSize: '2rem',
                                            color: '#fff',
                                            zIndex: 2
                                        }}><FaRegCirclePlay /></div>}
                                    </div>
                                ) : (
                                    <div style={{ width: '100%', height: '300px', position: 'relative', overflow: 'hidden', borderRadius: '18px' }}>
                                        <img
                                            src={mediaUrl}
                                            alt={`Preview ${assetType}`}
                                            style={{ 
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                borderRadius: '18px'
                                            }}
                                        />
                                    </div>
                                )}
                                <div className="likes space-x-3">
                                    <div
                                        className={`like-icon ${fav ? "liked" : ""}`}

                                        style={{ cursor: "pointer" }}
                                    >
                                        {fav ? (
                                            <span style={{ color: "red" }} onClick={handleLike}>{likeCount} ❤️</span>
                                        ) : (
                                            <span style={{ color: "red" }} onClick={handleLike}> <span> {Number(likeCount) !== 0 && likeCount} </span>♡</span>
                                        )}
                                    </div>
                                </div>
                            </div>


                            {/* Footer Section */}
                            <div className="card_footer d-block space-y-10">
                                <div
                                    className="d-flex align-items-center space-x-10 justify-content-between"
                                >
                                    <div className="d-flex align-items-center space-x-5" onClick={() => redirect()}>
                                        <h6 className="card_title">
                                            <div
                                                className="color_black"
                                                style={{ textTransform: "capitalize" }}
                                            >
                                                {hover ? title : title?.slice(0, 15) + (title?.length > 15 ? "..." : "")}
                                            </div>
                                        </h6>
                                    </div>

                                    {button && (
                                        <button
                                            className="btn btn-sm btn-primary"
                                            disabled={isListed}
                                            onClick={() => { buttonMessage !== "draft" && onTrade({ tokenId, contractAddress, price }) }}
                                        >
                                            {buttonMessage === "draft" ? "View" : buttonMessage}
                                        </button>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* </Link> */}
            </div>


            <Modal show={openModalState} size="lg" onHide={closeModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Select an action for the {title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h3>Select an option to send or add to the market</h3>
                    {!nftAction && (
                        <div className="my-2">
                            <Button onClick={() => setNftAction('send')}>Send</Button>
                            <Button onClick={() => setNftAction('market')} className="mx-3">
                                Add to Market
                            </Button>
                        </div>
                    )}
                    {nftAction === 'send' && (
                        <div className='my-4'>
                            <h4>Enter recipient's wallet address</h4>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Wallet Address"
                                value={receiverAddress}
                                onChange={(e) => setReceiverAddress(e.target.value)}
                            />
                        </div>
                    )}
                    {nftAction === 'market' && (
                        <div className='my-4'>
                            <h4>Set Price for Redeployment</h4>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Price"
                                value={priceforMarket}
                                onChange={(e) => setPriceForMarket(e.target.value)}
                            />
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={closeModal}>Cancel</Button>
                    <Button
                        onClick={() => {
                            if (nftAction === 'market') {
                                redeployOnMarketplace();
                            } else if (nftAction === 'send') {
                                sendNFT();
                            }
                        }}
                    >
                        {nftAction === 'market' ? 'Add to Market' : 'Send'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>

    );
};

// Prop Validation
DynamicCardProfile.propTypes = {
    NFTLink: PropTypes.string,
    contractAddress: PropTypes.string,
    creatorProfile: PropTypes.string,
    creatorName: PropTypes.string,
    creatorLink: PropTypes.string,
    mediaUrl: PropTypes.string,
    assetType: PropTypes.string,
    isVideo: PropTypes.bool,
    title: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    likes: PropTypes.number,
    isLiked: PropTypes.bool,
    isListed: PropTypes.bool,
    button: PropTypes.bool,
    buttonMessage: PropTypes.string,
    isProfile: PropTypes.bool,
    isCollection: PropTypes.bool,
    isLazy: PropTypes.bool

};

DynamicCardProfile.defaultProps = {
    NFTLink: "nftType/contactAddress/tokenId(_id)",
    contractAddress: "contractAddress",
    creatorProfile: { DefaultProfile },
    creatorName: "Unknown",
    creatorLink: `${`/otherProfile/creatorAddress`}`,
    mediaUrl: itemLogo,
    assetType: "image",
    isVideo: false,
    title: "title",
    price: null,
    likes: 0,
    isLiked: false,
    isListed: true,
    button: false,
    buttonMessage: "Button",
    isProfile: true,
    isCollection: true,
    isLazy: false
};

export default DynamicCardProfile;
